import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-type-chooser" }

import { type OtTabType } from '@1trading/design-system';
import { find, propEq } from 'lodash/fp';
import type { PropType } from 'vue';
import { computed } from 'vue';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { OrderType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

import type { OrderTypeOption } from './OrderTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderTypeChooser',
  props: {
  availableTypes: { type: Array as PropType<Array<OrderTypeOption>>, required: true },
  selectedType: { type: String as PropType<OrderType>, required: true },
  isFutures: { type: Boolean, required: false, default: false },
},
  emits: ["type-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { isXS } = useMQBreakpoints();

const activeTypeOption = computed(() => find(propEq('type', props.selectedType), props.availableTypes));

const tabs = computed(() =>
  props.availableTypes.map((typeOption) => ({
    getTitle: () => typeOption.label,
    id: typeOption.type,
    active: props.selectedType === typeOption.type,
  })),
);

const onTypeSelected = (type: OrderType) => {
  emit('type-selected', type);
};

const onSelectValueChange = (value: OrderTypeOption) => {
  onTypeSelected(value.type);
};

const onTabSelected = (tab: OtTabType<string>) => {
  onTypeSelected(tab.id as OrderType);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_select = _resolveComponent("ot-select")!
  const _component_ot_tabs = _resolveComponent("ot-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isXS))
      ? (_openBlock(), _createBlock(_component_ot_select, {
          key: 0,
          class: "order-type-chooser__select",
          label: "label",
          options: __props.availableTypes,
          value: activeTypeOption.value,
          disabled: __props.availableTypes.length < 2,
          "onUpdate:value": onSelectValueChange
        }, null, 8, ["options", "value", "disabled"]))
      : (_openBlock(), _createBlock(_component_ot_tabs, {
          key: 1,
          class: "order-type-chooser__tabs",
          tabs: tabs.value,
          dense: true,
          onTabSelected: onTabSelected
        }, null, 8, ["tabs"]))
  ]))
}
}

})